import { AxiosInstance } from "axios"

import { ApiPaths } from "~/enums"

export const customer = (axios: AxiosInstance) => ({
  create: () => axios.post(ApiPaths.CREATE_CUSTOMER),
})
